var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Posts',{attrs:{"startId":_vm.startId,"type":_vm.type},on:{"changed":_vm.onPostChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }